import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function DateRangeValidator(minDate: Date, maxDate: Date): ValidatorFn {
    
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value == null) return { invalidDateRange: { value: control.value } }
        const validDate = control.value.getTime() < maxDate.getTime() && control.value.getTime() > minDate.getTime();
        return validDate ? null : { invalidDateRange: { value: control.value } }
    };
}